import { EmptyState } from '@app/components/base/EmptyState';
import { defineMessage, FormattedMessage } from 'react-intl';
import { CreateVideoEditionProjectButton } from './CreateVideoEditionProjectButton';

const videoEditionsEmptyHelpMessage = defineMessage({
  id: 'fragments.videoEditions.emptyHelp',
  defaultMessage: 'No hay proyectos de edición aún',
});

export interface FragmentVideoEditionsProjectsEmptyStateProps {
  fragmentId: string;
}

/**
 * Centered empty state when the fragment has no video edition projects.
 */
export function FragmentVideoEditionsProjectsEmptyState({
  fragmentId,
}: FragmentVideoEditionsProjectsEmptyStateProps) {
  return (
    <EmptyState
      centered
      message={false}
      help={<FormattedMessage {...videoEditionsEmptyHelpMessage} />}
      action={<CreateVideoEditionProjectButton fragmentId={fragmentId} currentProjectCount={0} />}
    />
  );
}
